module.exports = __webpack_public_path__ + "img/project-2.0a9be7f4.jpg";